import VideoEditor from '@intercom/embercom-composer/components/video-editor';
export default VideoEditor;
